<template>
	<div class="page">
		<div title="talentTemplate" is='headered'></div>
		<div class="public_title">
			<div>青年阶段——</div>
			<div>高校双创就业指导</div>
			<div class="public_titleImg">
				<img src="../../assets/公众号.png"/>
				<div>青少年创新项目管理集训营</div>
			</div>
		</div>	
		<div class="young2_text"> “项目管理校园行”为众多高职院校学生提供项目式案例演练，模拟演练岗位，通过项目式案例教学能够胜任实践工作项目，提升就业技能。</div>
		<div class="young2_text">2014年起在山东省内多所高校展开“项目管理校园行”就业指导，即项目式PBL案例实训演练。截至2020年1月，学生培训共63000人次以上。 </div>
		<div class="young2_text">合作院校有山东大学、山东职业学院、山东商业职业学院、山东城市建设职业学院、山东农业工程学院、山东交通学院、山东外国语大学、山东水 利职业学院、中国石油大学华东校区、山东信息技术职业学院、山东现代学院、青岛黄海学院、青岛职业技术学院、烟台大学、烟台南山学院、日照职 业技术学院、济宁职业学院、潍坊科技学院、泰山职业技术学院等。</div> 
		<div style="margin-bottom: 60px;" class="young2_text">学生参加过案例演练后可参加笔试获得国际项目管理协会在全球通行的资质认证IPMP-D级国际项目经理证书。公司在高校项目式教学领域和项目 经理资质认证领域的两项业务相辅相成，为在校学生通过项目式技能实训后走向工作岗位提供无缝衔接的培训体系，这样的毕业生更能胜任工作岗位。</div>
		<div class="young2_img1">
			<img src="../../assets/stageImg/youngStage_new.png"/>
			<div>
				<img src="../../assets/stageImg/young_footImg11.jpg"/>
				<img src="../../assets/stageImg/stage3_22.jpg"/>
			</div>
			
		</div>
		
<!--		
		
		<div class="young2_img2">
			<img src="../../assets/stageImg/stage3_1.png"/>
			<img src="../../assets/stageImg/young_footImg11.jpg"/>
		</div>
		
		<div class="young2_img2">
			<img src="../../assets/stageImg/young_footImg22.jpg"/>
			<img src="../../assets/stageImg/stage3_22.jpg"/>
		</div>-->
		
		<div class="young2_img2">
			<img src="../../assets/stageImg/young_footImg6.jpg"/>
			<img src="../../assets/stageImg/young_footImg5.jpg"/>
		</div>
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {}
		}
	}
</script>

<style scoped="scoped">
	.public_title {
		width: 1200px;
		margin: 0 auto;
		margin-top: 90px;
		margin-bottom: 60px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: center;
	}
	
	.public_title div {
		line-height: 48px;
		color: #1F2329;
		font-size: 36px;
		text-align: left;
		font-weight: bold;
	}
	
	.public_title>div:nth-child(2) {
		color: #0080FF;
		margin-right: 50px;
	}
	.public_title .public_titleImg{
		width: 200px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.public_title .public_titleImg img{
		width: 100px;
		height: 100px;
	}
	.public_title .public_titleImg div{
		font-size: 14px;
		line-height: 20px;
		width: 200px;
		text-align: center;
		color: #333;
	}
	.young2_text{
		width: 1200px;
		margin: 0 auto;
		line-height: 30px;
		font-size: 18px;
		text-align: left;
		color: #51565D;	
		text-indent: 2em;
	}
	.young2_img{	
		width: 1000px;
		margin: 0 auto;
		margin-bottom: 60px;
	}
	.young2_img1{
		width: 1200px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		margin-bottom: 120px;
	}
	.young2_img1>img{
		width: 560px;
	}
	.young2_img1>div{
		width: 560px;
	}
	.young2_img1>div img{
		width: 560px;
		height: 375px;
		margin-bottom: 120px;
	}
	.young2_img1>div img:nth-child(2){
		margin-bottom: 0px;
	}
	.young2_img2{
		width: 1200px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin: 0 auto;
		margin-bottom: 120px;
	}
	.young2_img2 img{
		width: 560px;
		height: 293px;
	}
</style>


// WEBPACK FOOTER //
// src/views/phaseList/youngStage2.vue